<template>
        <nuxt-img
            width="2000"
            height="2000"
            class="w-full h-full object-cover "
            sizes="sm:440px  md:100vw lg:100vw xl:2000px"
            :src="image"
            :alt="imageAlt"
            preload
            format="webp"
        />
</template>

<script setup>

defineProps({
  image: {
    type: String,
    default: '/assets/images/sips-seasonal-tips.jpg',
  },
  imageAlt: {
    type: String,
    default: 'schedule',
  },

})

defineBuilderComponent({
    friendlyName: "Schedule",
    canHaveChildren: true,
    inputs: [
        {
            name: "image",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "/assets/images/sips-seasonal-tips.jpg"
        },
        {
            name: "imageAlt",
            type: "text",
            defaultValue: "schedule"
        }
    ]
});
</script>